import { render, staticRenderFns } from "./ModalTermsContainer.vue?vue&type=template&id=ddef05d2&scoped=true&"
import script from "./ModalTermsContainer.vue?vue&type=script&lang=js&"
export * from "./ModalTermsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddef05d2",
  null
  
)

export default component.exports